import { Component, OnInit } from '@angular/core';
import {NotificationsService} from '@modules/notification/core/notifications.service';
import {Router} from '@angular/router';
import {defaultLoginRoute} from '../../../settings';
import {NotificationsServiceCitizen} from "@modules/notification/core/notifications.service.citizen";

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent implements OnInit {

    constructor(private notificationService: NotificationsService, private notificationCitizenService: NotificationsServiceCitizen, private router: Router) {
    }

  ngOnInit() {
      if (!this.notificationService.settings.show) {
          this.router.navigate([defaultLoginRoute]);
      }
  }

  close() {
        this.notificationCitizenService.closeNotificationDialog();
  }

}
